export default "__VITE_ASSET__cf24351b__"